// DS: i3.15
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Refresh: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path d="M12.9 12.792v.892c0 .505.406.915.908.915s.91-.41.91-.915v-2.88a.91.91 0 0 0-.91-.914h-2.82a.91.91 0 0 0-.908.915c0 .505.407.915.909.915h.406a4.9 4.9 0 0 1-4.5 1.337c-1.987-.426-3.452-2.011-3.848-3.931a.914.914 0 0 0-1.074-.716.91.91 0 0 0-.704 1.08c.536 2.6 2.528 4.773 5.256 5.36 2.423.52 4.809-.345 6.374-2.058M4.605 4.28h.407c.502 0 .909.41.909.915a.91.91 0 0 1-.91.915H2.193a.91.91 0 0 1-.909-.915v-2.88c0-.505.407-.914.91-.914.501 0 .908.41.908.915v.891C4.667 1.495 7.052.63 9.475 1.15c2.729.587 4.72 2.76 5.256 5.36a.91.91 0 0 1-.704 1.08.914.914 0 0 1-1.074-.716c-.395-1.92-1.861-3.505-3.847-3.932A4.9 4.9 0 0 0 4.605 4.28"></path>
    </svg>
  </IconWrap>
);
Refresh.displayName = 'Refresh';

export default Refresh;
